import { defaultBreaksFieldGroupValidator } from './DefaultBreaksFieldGroup';
import { FormFields } from './makeFormFields';

export default function validate(formFields: FormFields) {
  return {
    ...defaultBreaksFieldGroupValidator(formFields),
  };
}
